module.exports = __webpack_public_path__ + "35b72390ca2d92b1c9c1a5a3da0b0130.png";